export default __webpack_public_path__ + "static/media/BPS-Banner-detail.d5013147.png";